import { SaveOutlined } from '@ant-design/icons';
import { Button, Drawer, Form, Input, Select, Space, notification } from 'antd';
import { React } from 'react';
import { useAddShoppingFeedAttribute } from '../../../../utils/api/mpCategories/useAddShoppingFeedAttribute';

const CreateAttributeDrawer = ({ open, category, onClose }) => {
  const [form] = Form.useForm();
  const { addAttribute, isAdding } = useAddShoppingFeedAttribute();

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      addAttribute(
        {
          categoryId: category?.id,
          code: values.code,
          name: values.name,
          requirement: values.requirement,
          format: values.format,
        },
        {
          onSuccess: () => {
            notification.success({
              message: 'Attribut créé',
              description: `L'attribut "${values.name}" a été créé avec succès`,
              placement: 'bottomRight',
              duration: 3,
            });
            form.resetFields();
            onClose();
          },
          onError: (error) => {
            notification.error({
              message: 'Erreur',
              description:
                error?.response?.data?.error ||
                error?.message ||
                "Impossible de créer l'attribut",
              placement: 'bottomRight',
              duration: 3,
            });
          },
        }
      );
    });
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Drawer
      title="Créer un attribut Shopping Feed"
      placement="right"
      onClose={handleClose}
      open={open}
      width={500}
      styles={{
        body: { padding: '24px' },
      }}
      extra={
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSubmit}
          loading={isAdding}
        >
          Enregistrer
        </Button>
      }
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            requirement: 'optional',
            format: 'text',
          }}
        >
          <Form.Item
            name="code"
            label="Code"
            rules={[{ required: true, message: 'Le code est requis' }]}
          >
            <Input placeholder="ex: product_color" />
          </Form.Item>

          <Form.Item
            name="name"
            label="Nom"
            rules={[{ required: true, message: 'Le nom est requis' }]}
          >
            <Input placeholder="ex: Couleur du produit" />
          </Form.Item>

          <Form.Item name="requirement" label="Niveau d'exigence">
            <Select
              options={[
                { label: 'Optionnel', value: 'optional' },
                { label: 'Conseillé', value: 'recommended' },
                { label: 'Requis', value: 'required' },
              ]}
            />
          </Form.Item>

          <Form.Item name="format" label="Format">
            <Select
              options={[
                { label: 'Texte', value: 'text' },
                { label: 'Nombre entier', value: 'number' },
                { label: 'Décimal', value: 'decimal' },
                { label: 'Liste', value: 'list' },
                { label: 'Booléen', value: 'boolean' },
              ]}
            />
          </Form.Item>
        </Form>
      </Space>
    </Drawer>
  );
};

export default CreateAttributeDrawer;
